import React from 'react';
import { Container } from "react-bootstrap";
import styles from './HeaderMoveControl.module.css';
import logo from '../../assets/icons/qvh-logo.svg';

const HeaderMoveControl = () => {
  return (
    <>
      <header className={styles["custom-header"]}>
        <Container fluid className={styles["header-container"]}>
          
          <img
            src={logo}
            alt="QVH Logo"
            className={styles["header-logo"]}
          />

          <div className={styles["header-title"]}></div>
        </Container>
      </header>

      <div className={styles["header-divider-upper"]}></div>
      <div className={styles["header-divider"]}></div>
    </>
  );
};

export default HeaderMoveControl;
